import React from 'react';

import { Divider} from 'antd';
import { Composicoes } from './Composicoes';
import { FormPreencheComposicao } from './form-preenche-composicao';

const TabComposicao = ({getApi, form}) => {
    return <div>
        <FormPreencheComposicao form={form} getApi={getApi}></FormPreencheComposicao>

        <Divider>Composições do Produto</Divider>

        <Composicoes />

    </div>;
}

export {TabComposicao}